     
            <div class="radio-cards-container" style="max-width: 100%;" [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''">
                                    
                <label class="radio-card-label-amh" *ngIf="!isAbutmenthighlySelected" (click)="onAabutmentStep4Selection('Subgingival depth')" style="width:30%">
                    <input type="radio" name="amh-{{anterior}}-reference-point3" class="hidden-radio-input" [checked]="shouldBeCheckedForTooth('abutmentStep4','Subgingival depth')" value="Subgingival depth" />
                    <div class="custom-radio-indicator"><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                         <app-magnifier [contentTemplate]="apppropahtml100081"></app-magnifier>
                        <ng-template #apppropahtml100081>
                           <div class="magnify-content magnify-small">
                                  <div class="img-center">
                               <img   height="70px" src="Asset_Image_Gity_V3/Height_of_the_marginal_preparation_margin/Subgingival_Depht.png" />
                               <div class="card-text">Subgingival depth</div>
                               <div class="card-subtext" >distance from gingival<br /> margin to abutment edge.</div>
                            </div>
                            </div>
                        </ng-template>
                    </div>
                    
                    <div class="radio-card-overlay"></div>
                </label>
                <label class="radio-card-label-amh" [class]="isAbutmenthighlySelected?'card-left-align':''" (click)="onAabutmentStep4Selection('Tight connection')" style="width:30%">
                    <input type="radio" name="amh-{{anterior}}-reference-point3" class="hidden-radio-input" [checked]="shouldBeCheckedForTooth('abutmentStep4','Tight connection')" value="Tight connection"  />
                    <div class="custom-radio-indicator"><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                       
                          <app-magnifier [contentTemplate]="apppropahtml100082"></app-magnifier>
                        <ng-template #apppropahtml100082>
                           <div class="magnify-content magnify-small">
                                  <div class="img-center">
                             <img   height="70px"  src="Asset_Image_Gity_V3/Height_of_the_marginal_preparation_margin/Tight_Connection.png"  />
                              <div class="card-text">Tight connection</div>
                              <div class="card-subtext">As close as possible to <br />the connection point</div>
                            </div>
                            </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label class="radio-card-label-amh" *ngIf="!isAbutmenthighlySelected" (click)="onAabutmentStep4Selection('Reference point')" style="width:30%">
                    <input type="radio" name="amh-{{anterior}}-reference-point3" class="hidden-radio-input" [checked]="shouldBeCheckedForTooth('abutmentStep4','Reference point')" value="Reference point" />
                    <div class="custom-radio-indicator"><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">        
                         <app-magnifier [contentTemplate]="apppropahtml100083"></app-magnifier>
                        <ng-template #apppropahtml100083>
                           <div class="magnify-content magnify-small">
                                  <div class="img-center">
                             <img  height="70px"  src="Asset_Image_Gity_V3/Height_of_the_marginal_preparation_margin/Reference_Point.png"  />
                               <div class="card-text">Reference point</div>
                             <div class="card-subtext">0 mm = gingival margin <br> adjacent tooth.</div>
                            </div>
                            </div>
                        </ng-template>
                    </div>
                  
                    <div class="radio-card-overlay"></div>
                </label>
                
                

            </div>
            <div class="mt-2" style="display: flex;justify-content: space-between;gap:35px;">
            <div style="width:100%">
                    <div class="d-flex align-items-center justify-content-between" style="width: 100%;padding-top:20px;cursor: pointer;">
                        <div class="mb-1">Adjust All</div>
                        <div (click)="setAllParamValue('adjustAll', 0)" >
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2232_6455)">
                                    <path d="M9 0C6.7665 0 4.63425 0.83325 3 2.29275V0H1.5V3.75C1.5 4.57725 2.17275 5.25 3 5.25H6.75V3.75H3.645C5.04525 2.32425 6.97275 1.5 9 1.5C13.1355 1.5 16.5 4.8645 16.5 9C16.5 13.1355 13.1355 16.5 9 16.5C4.8645 16.5 1.5 13.1355 1.5 9H0C0 13.9628 4.03725 18 9 18C13.9628 18 18 13.9628 18 9C18 4.03725 13.9628 0 9 0Z" fill="black"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_2232_6455">
                                        <rect width="18" height="18" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            Reset adjustments
                        </div>
                    </div>
                    <div class="d-flex gap-2">
                        <input  type="number" [ngModel]="getAllParamValue('adjustAll')" (ngModelChange)="setAllParamValue('adjustAll', $event)" [ngModelOptions]="{ standalone: true }" class="customInputFields" style="width: 100px; height: 45px;" [max]="4" [min]="-4" [step]=".1"/>   
                        <mat-slider class="m-0" [min]="-4" [max]="4" [discrete]="true" [step]=".1" style="width: 100%;" >
                            <input matSliderThumb [ngModel]="getAllParamValue('adjustAll')" (ngModelChange)="setAllParamValue('adjustAll', $event)" #slider>
                        </mat-slider>
                    </div>
                </div>
            </div>
            <div class="mt-2" style="display: flex;justify-content: space-between;gap:35px;">
                <div style="width:100%">
                    <div class="d-flex align-items-center justify-content-between" style="width: 100%;">
                        <p class="mb-1">Mesial (mm)</p>
                    </div>
                    <div class="d-flex gap-2">
                        <input  type="number" [ngModel]="getParamValue('mesial')" (ngModelChange)="setParamValue('mesial', $event)" [ngModelOptions]="{ standalone: true }" class="customInputFields" style="width: 100px; height: 45px;" [max]="4" [min]="-4" [step]=".1"/>   
                        <mat-slider class="m-0" [min]="-4" [max]="4" [discrete]="true" [step]=".1" style="width: 100%;" >
                            <input matSliderThumb [ngModel]="getParamValue('mesial')" (ngModelChange)="setParamValue('mesial', $event)" #slider>
                        </mat-slider>
                    </div>
                </div>
                <div style="width:100%">
                    <div class="d-flex align-items-center justify-content-between" style="width: 100%;">
                        <p class="mb-1">Distal (mm)</p>
                    </div>
                    <div class="d-flex gap-2">
                        <input  type="number" [ngModel]="getParamValue('distal')" (ngModelChange)="setParamValue('distal', $event)" [ngModelOptions]="{ standalone: true }" class="customInputFields" style="width: 100px; height: 45px;" [max]="4" [min]="-4" [step]=".1"/>   
                        <mat-slider class="m-0" [min]="-4" [max]="4" [discrete]="true" [step]=".1" style="width: 100%;" >
                            <input matSliderThumb [ngModel]="getParamValue('distal')" (ngModelChange)="setParamValue('distal', $event)" #slider>
                        </mat-slider>
                    </div>
                </div>
            </div>
            
            <div class="mt-2" style="display: flex;justify-content: space-between;gap:35px;">
                <div style="width:100%">
                    <div class="d-flex align-items-center justify-content-between" style="width: 100%;">
                        <p class="mb-1">Vestibular (mm)</p>
                    </div>
                    <div class="d-flex gap-2">
                        <input  type="number"  [ngModel]="getParamValue('vestibular')" (ngModelChange)="setParamValue('vestibular', $event)" [ngModelOptions]="{ standalone: true }" class="customInputFields" style="width: 100px; height: 45px;" [max]="4" [min]="-4" [step]=".1"/>  
                        <mat-slider class="m-0" [min]="-4" [max]="4" [discrete]="true" [step]=".1" style="width: 100%;" >
                            <input matSliderThumb  [ngModel]="getParamValue('vestibular')" (ngModelChange)="setParamValue('vestibular', $event)" #slider>
                        </mat-slider>
                    </div>
                </div>
                <div style="width:100%">
                    <div class="d-flex align-items-center justify-content-between" style="width: 100%;">
                        <p class="mb-1">Oral (mm)</p>
                    </div>
                    <div class="d-flex gap-2">
                        <input  type="number" [ngModel]="getParamValue('oral')" (ngModelChange)="setParamValue('oral', $event)" [ngModelOptions]="{ standalone: true }" class="customInputFields" style="width: 100px; height: 45px;" [max]="4" [min]="-4" [step]=".1"/>
                        <mat-slider class="m-0" [min]="-4" [max]="4" [discrete]="true" [step]=".1" style="width: 100%;" >
                            <input matSliderThumb [ngModel]="getParamValue('oral')" (ngModelChange)="setParamValue('oral', $event)" #slider>
                        </mat-slider>
                    </div>
                </div>
            </div>

            <div class="info-divider mt-4" *ngIf="readonly"></div>

